export const TOOL_PERMISSION = {
  VIEW: 'EQM_TOOL_VIEW',
  MASTER_MANAGE: 'EQM_TOOL_MASTER_MANAGE',
  RECEIVE: 'EQM_TOOL_RECEIVE',
  ISSUE: 'EQM_TOOL_ISSUE',
  ISSUE_APPROVE: 'EQM_TOOL_ISSUE_APPROVE',
  RECOVER: 'EQM_TOOL_RECOVER',
  TRANSFER: 'EQM_TOOL_TRANSFER',
  ALLOCATION_CALCULATE: 'EQM_TOOL_ALLOCATION_CALCULATE',
  ALLOCATION_APPROVE: 'EQM_TOOL_ALLOCATION_APPROVE',
  ALLOCATION_POST: 'EQM_TOOL_ALLOCATION_POST',
  JOURNAL_REVERSE: 'EQM_TOOL_JOURNAL_REVERSE',
  STOCKTAKE: 'EQM_TOOL_STOCKTAKE',
  LOSS_DAMAGE: 'EQM_TOOL_LOSS_DAMAGE',
  LIQUIDATE: 'EQM_TOOL_LIQUIDATE',
  VALUE_VIEW: 'EQM_TOOL_VALUE_VIEW',
  REPORT_VIEW: 'EQM_TOOL_REPORT_VIEW',
  IMPORT_EXPORT: 'EQM_TOOL_IMPORT_EXPORT',
  ACCOUNTING_CONFIG: 'EQM_TOOL_ACCOUNTING_CONFIG',
  READINESS_VIEW: 'EQM_TOOL_READINESS_VIEW',
  JOURNAL_PREVIEW: 'EQM_TOOL_JOURNAL_PREVIEW',
  REPAIR_VIEW: 'EQM_TOOL_REPAIR_VIEW',
  REPAIR_MANAGE: 'EQM_TOOL_REPAIR_MANAGE',
  REPAIR_APPROVE: 'EQM_TOOL_REPAIR_APPROVE',
  SCHEDULER_CONFIG: 'EQM_TOOL_SCHEDULER_CONFIG',
  SCHEDULER_RUN: 'EQM_TOOL_SCHEDULER_RUN',
};

export const VIEWS = {
  dashboard: { title: 'Tổng quan công cụ dụng cụ', documentType: null },
  catalog: { title: 'Danh mục công cụ dụng cụ', documentType: null },
  receipts: { title: 'Nhập kho công cụ dụng cụ', documentType: null },
  issues: { title: 'Cấp phát công cụ dụng cụ', documentType: 'ISSUE' },
  recoveries: { title: 'Thu hồi công cụ dụng cụ', documentType: 'RECOVERY' },
  transfers: { title: 'Điều chuyển công cụ dụng cụ', documentType: 'TRANSFER' },
  assignments: { title: 'Công cụ dụng cụ đang sử dụng', documentType: null },
  allocations: { title: 'Phân bổ công cụ dụng cụ', documentType: null },
  stocktakes: { title: 'Kiểm kê công cụ dụng cụ', documentType: 'STOCKTAKE' },
  incidents: { title: 'Báo mất/hỏng công cụ dụng cụ', documentType: 'LOSS_DAMAGE' },
  liquidations: { title: 'Thanh lý công cụ dụng cụ', documentType: 'LIQUIDATION' },
  repairs: { title: 'Sửa chữa công cụ dụng cụ', documentType: null },
  reports: { title: 'Báo cáo công cụ dụng cụ', documentType: null },
  settings: { title: 'Thiết lập công cụ dụng cụ', documentType: null },
};

export const DOCUMENT_STATUS = {
  DRAFT: { label: 'Nháp', color: 'default' },
  PENDING_APPROVAL: { label: 'Chờ duyệt', color: 'processing' },
  APPROVED: { label: 'Đã duyệt', color: 'cyan' },
  EXECUTED: { label: 'Đã thực hiện', color: 'blue' },
  POSTED: { label: 'Đã ghi sổ', color: 'success' },
  AUTO_POSTED: { label: 'Tự động ghi sổ', color: 'success' },
  DRAFT_CREATED: { label: 'Đã tạo bảng phân bổ nháp', color: 'processing' },
  NOTIFIED: { label: 'Đã thông báo', color: 'cyan' },
  SKIPPED: { label: 'Không có dữ liệu đến hạn', color: 'default' },
  BUSINESS_FAILED: { label: 'Lỗi nghiệp vụ', color: 'error' },
  TECHNICAL_FAILED: { label: 'Lỗi kỹ thuật', color: 'warning' },
  CANCELLED: { label: 'Đã hủy', color: 'error' },
  REVERSED: { label: 'Đã đảo bút toán', color: 'warning' },
};

export const REPORTS = [
  ['TOOL_DETAIL', 'Sổ chi tiết CCDC'],
  ['IN_OUT_STOCK', 'Bảng nhập – xuất – tồn CCDC'],
  ['IN_USE', 'Danh sách CCDC đang sử dụng'],
  ['BY_USER', 'CCDC theo người sử dụng'],
  ['BY_DEPARTMENT', 'CCDC theo phòng ban'],
  ['BY_LOCATION', 'CCDC theo địa điểm'],
  ['ALLOCATION', 'Bảng phân bổ CCDC'],
  ['ALLOCATED_VALUE', 'Giá trị đã phân bổ'],
  ['REMAINING_VALUE', 'Giá trị còn lại'],
  ['FULLY_ALLOCATED_IN_USE', 'CCDC đã phân bổ hết nhưng còn sử dụng'],
  ['LOSS_DAMAGE', 'CCDC mất/hỏng'],
  ['PENDING_LIQUIDATION', 'CCDC chờ thanh lý'],
  ['STOCK_ASSIGNMENT_RECONCILIATION', 'Đối chiếu tồn kho và cấp phát'],
  ['INVENTORY_ACCOUNT_RECONCILIATION', 'Đối chiếu tài khoản CCDC'],
  ['PREPAID_ACCOUNT_RECONCILIATION', 'Đối chiếu chi phí chờ phân bổ'],
  ['JOURNAL_RECONCILIATION', 'Đối chiếu bút toán tự động'],
];

export const moneyText = (value) =>
  Number(value || 0).toLocaleString('vi-VN', { maximumFractionDigits: 4 });
